import script from "./slideover.vue?vue&type=script&setup=true&lang=js"
export * from "./slideover.vue?vue&type=script&setup=true&lang=js"

import "./slideover.vue?vue&type=style&index=0&id=96b20936&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96b20936"]])

export default __exports__